import React from "react";
import { Dropdown, Form, Grid, Input } from "semantic-ui-react";
import BCAddressForm from "../ui/BCAddressForm";
import { getDropdownOptions } from "../../Helpers";

const LOBorrowerForm = ({ ...props }) => {
  const EntitySubTypes = ["EntitySubType1", "EntitySubType2"];
  const handleFormChange = (value, field) => {
    props.newBorrower[field] = value;
    props.setNewBorrower(props.newBorrower);
  };

  return (
    <div>
      <Form className="">
        <Grid className="">
          <Grid.Row>
            <Grid.Column width={16}>
              <Form.Field className="">
                <label>Borrower Name: </label>
                <Input 
                  placeholder="Loan Construction Services II, LLC" 
                  onChange={(e) => handleFormChange(e.target.value, "borrowerName")}
                  type="text"
                  fluid 
                />
              </Form.Field>
            </Grid.Column>
            <Grid.Column width={16}>
              <Form.Field className="">
                <label>Entity Sub Type: </label>
                <Dropdown
                  placeholder="Entity Sub Type 1"
                  fluid
                  search
                  selection
                  options={getDropdownOptions(EntitySubTypes)}
                  onChange={(e, { value }) => handleFormChange(value, "entitySubType")}
                />
              </Form.Field>
            </Grid.Column>
            <BCAddressForm handleFormChange={handleFormChange} />
            <Grid.Column width={16}>
              <Form.Field className="">
                <label>Website: </label>
                <Input 
                  placeholder="https://example.com" 
                  onChange={(e) => handleFormChange(e.target.value, "website")}
                  type="text"
                  fluid 
                />
              </Form.Field>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    </div>
  );
};

export default LOBorrowerForm;